<mat-toolbar>
    <button mat-flat-button class="nav-button" (click)="scrollTop()">NBA Knowledge Graph</button>
    <a mat-flat-button class="nav-button" href="/nba/player">Player List</a>
    <span class="spacer"> </span>
    <a mat-flat-button class="nav-button" href="http://204.236.183.97:7474/browser/">Neo4j Endpoint</a>
</mat-toolbar>